var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "simple-form" }, [
    _c("div", { staticClass: "form-group center" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-value " },
        [
          _c("el-input", {
            staticClass: "width-1-5x bottom-line",
            attrs: { disabled: true },
            model: {
              value: _vm.goodsWrntExtVoucher.sellerName,
              callback: function($$v) {
                _vm.$set(_vm.goodsWrntExtVoucher, "sellerName", $$v)
              },
              expression: "goodsWrntExtVoucher.sellerName"
            }
          }),
          _vm._v(" "),
          _vm.show
            ? _c("i", {
                staticClass:
                  "icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                on: {
                  click: function($event) {
                    _vm.showVendorDlg()
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("资产信息")]),
      _vm._v(" "),
      _vm.goodsWrntExtVoucher.goodsWrntExtItems != null
        ? _c("span", { staticClass: "fr font12" }, [
            _vm._v(
              "已选择(" +
                _vm._s(_vm.goodsWrntExtVoucher.goodsWrntExtItems.length) +
                ")"
            )
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "simple-row" }, [
      _vm.goodsWrntExtVoucher.sellerId != null && _vm.show
        ? _c("div", { staticClass: "left" }, [
            _c(
              "button",
              {
                staticClass: "swb-btn swb-btn-small",
                on: {
                  click: function($event) {
                    _vm.showDeviceListDlg()
                  }
                }
              },
              [_c("span", [_vm._v("选择")])]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.goodsWrntExtVoucher.sellerId != null && _vm.show
        ? _c("div", { staticClass: "right" }, [
            _c(
              "button",
              {
                staticClass: "swb-btn swb-btn-small",
                on: {
                  click: function($event) {
                    _vm.batchGoodsWrntExtDlg()
                  }
                }
              },
              [_c("span", [_vm._v("批量延保")])]
            )
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "table-layout" }, [
      _c(
        "div",
        { staticStyle: { width: "100%", "overflow-x": "auto" } },
        [
          _c(
            "el-form",
            {
              ref: "goodsWrntExtVoucher",
              attrs: { model: _vm.goodsWrntExtVoucher, rules: _vm.rules }
            },
            [
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.goodsWrntExtVoucher.goodsWrntExtItems,
                    border: ""
                  },
                  on: { "selection-change": _vm.handleSelectionChange }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "selection",
                      width: "40",
                      align: "center",
                      fixed: "left"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "title",
                      width: "180",
                      label: "资产描述全称",
                      align: "left",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "name",
                      width: "180",
                      label: "名称",
                      align: "left",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "retailerBizUnitName",
                      width: "180",
                      label: "业务单元",
                      align: "left",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "retailerShopName",
                      width: "180",
                      label: "所属部门",
                      align: "left",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "model",
                      width: "150",
                      label: "型号",
                      align: "left",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "fixedSpec",
                      width: "150",
                      label: "规格",
                      align: "left",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "tmpNo",
                      width: "250",
                      label: "系统编号",
                      align: "left",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "ukNo",
                      width: "250",
                      label: "标识码",
                      align: "left",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "catName",
                      width: "100",
                      label: "分类",
                      align: "left",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "brandName",
                      width: "120",
                      label: "品牌",
                      align: "left",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "batchNo",
                      width: "160",
                      label: "批次号",
                      align: "left",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "price",
                      width: "130",
                      label: "原值（元）",
                      align: "right",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "recvDate",
                      width: "180",
                      label: "资产收货日期",
                      align: "left",
                      "show-overflow-tooltip": ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "wrntDueDateOld",
                      width: "180",
                      label: "原质保到期日",
                      align: "left",
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                disabled: "",
                                type: "date",
                                "value-format": "yyyy-MM-dd",
                                placeholder: "选择日期"
                              },
                              model: {
                                value: rows.row.wrntDueDateOld,
                                callback: function($$v) {
                                  _vm.$set(rows.row, "wrntDueDateOld", $$v)
                                },
                                expression: "rows.row.wrntDueDateOld"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _vm.show
                    ? _c("el-table-column", {
                        attrs: {
                          prop: "wrntPeriod",
                          width: "120",
                          label: "延保时长（月）",
                          align: "left",
                          "show-overflow-tooltip": ""
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(rows) {
                              return [
                                _c("el-input", {
                                  staticClass: "input-content-left",
                                  attrs: {
                                    id: "wrntPeriod" + rows.$index,
                                    type: "text"
                                  },
                                  on: {
                                    change: function($event) {
                                      _vm.changeWrntDueDateNew(
                                        rows.row,
                                        rows.$index
                                      )
                                    }
                                  },
                                  model: {
                                    value: rows.row.wrntPeriod,
                                    callback: function($$v) {
                                      _vm.$set(rows.row, "wrntPeriod", $$v)
                                    },
                                    expression: "rows.row.wrntPeriod"
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "wrntDueDateNew",
                      width: "180",
                      label: "新质保到期日",
                      align: "left",
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop:
                                    "goodsWrntExtItems." +
                                    rows.$index +
                                    ".wrntDueDateNew",
                                  rules: _vm.rules.validateFee
                                }
                              },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: !_vm.show,
                                    type: "datetime",
                                    format: "yyyy-MM-dd",
                                    placeholder: "选择日期"
                                  },
                                  on: {
                                    change: function($event) {
                                      _vm.clearWrntPeriod(rows.$index)
                                    }
                                  },
                                  model: {
                                    value: rows.row.wrntDueDateNew,
                                    callback: function($$v) {
                                      _vm.$set(rows.row, "wrntDueDateNew", $$v)
                                    },
                                    expression: "rows.row.wrntDueDateNew"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "fee",
                      width: "120",
                      label: "延保费用",
                      align: "left",
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(rows) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop:
                                    "goodsWrntExtItems." + rows.$index + ".fee",
                                  rules: _vm.rules.validateFee
                                }
                              },
                              [
                                _c("el-input", {
                                  staticClass: "input-content-left",
                                  attrs: { disabled: !_vm.show, type: "text" },
                                  model: {
                                    value: rows.row.fee,
                                    callback: function($$v) {
                                      _vm.$set(rows.row, "fee", $$v)
                                    },
                                    expression: "rows.row.fee"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _vm.show
                    ? _c("el-table-column", {
                        attrs: {
                          align: "center",
                          width: "80",
                          label: "操作",
                          "show-overflow-tooltip": "",
                          fixed: "right"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(rows) {
                              return [
                                _vm.show
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "swb-btn-link",
                                        on: {
                                          click: function($event) {
                                            _vm.deleteDevice(rows.$index)
                                          }
                                        }
                                      },
                                      [_vm._v("移除")]
                                    )
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "required" }, [_vm._v("供应商")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-079893c1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-079893c1","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/order/GoodsWrntExtVoucherSave.vue
// module id = 2984
// module chunks = 0